import {
    MSAL_GUARD_CONFIG,
    MSAL_INSTANCE,
    MSAL_INTERCEPTOR_CONFIG,
    MsalGuardConfiguration,
    MsalInterceptorConfiguration,
} from '@azure/msal-angular';
import {
    BrowserCacheLocation,
    InteractionType,
    IPublicClientApplication,
    LogLevel,
    PublicClientApplication,
} from '@azure/msal-browser';

import {environment} from '../../environments/environment';

export function loggerCallback(_logLevel: LogLevel, message: string): void {
    if (environment.environment !== 'prod') {
        console.log(`[MSAL] ${message}`);
    }
}

export function MSALInstanceFactory(): IPublicClientApplication {
    const {cloudInstanceId, tenantId, clientId} = environment.msal;

    return new PublicClientApplication({
        auth: {
            clientId,
            authority: `${cloudInstanceId}${tenantId}`,
        },
        cache: {
            cacheLocation: BrowserCacheLocation.LocalStorage,
        },
        system: {
            allowPlatformBroker: false,
            loggerOptions: {
                loggerCallback,
                logLevel: environment.environment === 'prod' ? LogLevel.Warning : LogLevel.Info,
                piiLoggingEnabled: false,
            },
        },
    });
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        authRequest: {
            scopes: [...environment.msal.baseScopes, environment.msal.apiScope, 'User.Read'],
        },
        loginFailedRoute: '/unauth',
    };
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, string[] | null>();

    // Same-origin API calls (Angular dev proxy in development -> /api/* is
    // forwarded to the backend; in prod the SPA and API share an origin).
    // Strict matching (v5 default) requires the `/*` suffix to cover sub-paths.
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    protectedResourceMap.set(`${origin}/api/*`, [environment.msal.apiScope]);

    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap,
    };
}

export const MSAL_PROVIDERS = [
    {provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory},
    {provide: MSAL_GUARD_CONFIG, useFactory: MSALGuardConfigFactory},
    {provide: MSAL_INTERCEPTOR_CONFIG, useFactory: MSALInterceptorConfigFactory},
] as const;
